<template>
  <div class="page-box">
    <PageSwiper location="NEWS" />

    <div class="page-nav">
      <img src="@/assets/home-icon.png" @click="gotoHome" />
      <div style="cursor: pointer" @click="gotoHome">首页 ></div>
      <div class="text">新闻中心</div>
    </div>

    <div class="detail">
      <div class="title">{{ detail.title }}</div>
      <div class="time-row">{{ detail.time }}</div>
      <div v-html="$utils.escape2Html(detail.content)"></div>
    </div>
  </div>
</template>
<script>
import PageSwiper from '@/components/PageSwiper'
export default {
  components: { PageSwiper },
  data() {
    return {
      currentId: '',
      detail: {},
    }
  },
  watch: {
    '$route'(to) {
      this.currentId = to.params.id
      this.getData()
    }
  },
  created() {
    this.currentId = this.$route.params.id
    this.getData()
  },
  methods: {
    gotoHome() {
      this.$router.replace({ name: 'home' })
    },
    getData() {
      this.$http.getAction(`/portal/api/v1/news/detail/${this.currentId}`).then((res) => {
        if (res.success) {
          this.detail = res.data
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.page-box {
  padding-bottom: 100px;
  flex: 1;

  .page-nav {
    display: flex;
    align-items: center;
    height: 80px;
    width: 1200px;
    font-weight: 500;
    font-size: 14px;
    color: #898989;
    margin: 0 auto;
    img {
      width: 20px;
      height: 20px;
      margin-right: 15px;
    }
    .text {
      padding-left: 6px;
      color: #333333;
    }
  }

  .detail {
    width: 1200px;
    margin: 0 auto;
    border-top: 1px solid #d4d7d9;
    padding-top: 30px;
    .title {
      width: 1000px;
      font-weight: bold;
      font-size: 24px;
      color: #000000;
      line-height: 40px;
      text-align: center;
      padding-bottom: 40px;
    }
    .time-row {
      height: 18px;
      font-weight: 500;
      font-size: 12px;
      color: #5A5A5A;
      line-height: 18px;
      padding-bottom: 20px;
    }
  }
}
</style>
